//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pin from "~/static/images/map-pin-icon2.png";
export default {
  data() {
    return {
      icon: pin,
      iconSize: [30, 30],
    };
  },

  computed: {
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15];
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15];
    },
  },
  props: {
    longitude: {
      type: Number,
      default: 0,
    },
    latitude: {
      type: Number,
      default: 0,
    },
    mapHeight: {
      type: String,
      default: "",
    },
    borderRadius: {
      type: String,
      default: "",
    },
  },
};
